import Vue from 'vue';
import Router from 'vue-router';

import middlewares from '@/core/services/routeMiddlewares.service';

import ManagerRouter from '@/manager/manager.router';
import ClientRouter from '@/client/client.router';
import PublicRouter from '@/public/public.router';
import StyleGuideRouter from '@/style-guide/style-guide.router';
import ClickBuyRouter from '@/clickbuy/clickbuy.router';
import LoginRouter from '@/login/login.router';

import PageNotFound from '@/core/views/page-not-found.view.vue';

Vue.use(Router);

export default new Router({
  mode: 'hash',
  routes: [
    ...PublicRouter,
    ...ManagerRouter,
    ...ClientRouter,
    ...StyleGuideRouter,
    ...ClickBuyRouter,
    ...LoginRouter,
    {
      path: '/',
      name: 'root',
      beforeEnter: middlewares.root,
    }, {
      path: '*',
      component: PageNotFound,
    },
  ],
});
